module.exports = __webpack_public_path__ + "7d088296/img/mini-logo.18817ee5.svg";